var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-button",class:{
    'key-takeaway': _vm.variant === 'key-takeaway',
  },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("icon",function(){return [(_vm.iconName)?_c('icon',{staticClass:"icon",attrs:{"name":_vm.iconName,"variant":_vm.iconVariant}}):_vm._e()]}),_vm._v(" "),_c('span',{staticClass:"label-text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.changeRootPTagToSpan(_vm.labelHtml))}}),_vm._v(" "),_vm._t("metadata")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }